import FondationsServiceModel from '@/models//FondationsServiceModel';

export default class UserResetPasswordModel extends FondationsServiceModel {
	static get path(): string {
		return '/users/reset_password';
	}
}
